import React,{useState} from 'react'
import Footer from '../components/Footer'

import Content from '../components/Content'
import "../App.css"
import Flow from '../components/carousels/Gallery'
import AboutUs from '../components/AboutUs'

import Room from '../components/Room'
import Gallery from '../components/Gallery'
import Restaraunt from '../components/Restaraunt'
import Button from '../components/Button'
import Nav from '../components/Nav'
import EventCaro from '../components/carousels/EventsCaro'
import Suites from "../components/carousels/Suites"
import Booking from "../components/Booking"
function Home() {
  const[style1,setStyle1]=useState("bg-[#d2a960] text-white w-1/2 z-2 ")
   const[style2,setStyle2]=useState("bg-white text-[#d2a960] w-1/2 ")
   const[table,setTable]=useState(false)
  return (
    <div>
    
      <div className="h-full bg bg-cover">
        <div className="h-full z-10 overlay"><Nav/>
          <div className="container landing mx-auto z-10 text-center">
            <Content title="LUXURY HOTEL & BEST RESORT"
            subtitle="LOREM IPSUM DOLOR SIT AMET"
            content="consectetur adipisicing elit. Repellendus aliquam maxime veniam adipisci et recusandae quibusdam ipsum, quisquam neque. Illum sunt similique alias nam fugiat, officiis voluptas veniam inventore! Esse"/>
          </div>
          <div className="container mx-auto border-solid border-2 h-20 border-[#d2a960] text-white justify-around flex flex-row w-4/5 text-center ">
            <div className={style1} onClick={()=>{setStyle1("bg-[#d2a960] text-white w-1/2 z-2 ");
            setStyle2("bg-white text-[#d2a960] w-1/2")
            setTable(false)}}>
              <p className="align-middle  p-5 md:text-2xl sm:text-xl">BOOK YOUR STAY</p></div>
      <div className={style2} onClick={()=>{setStyle1("bg-white text-[#d2a960] w-1/2");
            setStyle2("bg-[#d2a960] text-white w-1/2 z-2")
            setTable(true)}}>
              <p className="text-center p-5 md:text-2xl sm:text-xl">
 BOOK YOUR TABLE</p></div></div>

      </div>
      </div>
       <Booking show={table}/>

    <AboutUs/>
    
    <Room/>
    <div className="container mx-auto w-full">
    <Suites rotate={20} depth={700}/></div>
    <div className="bg-black p-10">
    <Restaraunt/>
   
    </div> <Gallery/>
    <div className="container mx-auto w-full">
    <Flow rotate={50} depth={100}/>
   </div>
  
   <div className="w-full md:grid grid-cols-3 grid-rows-1 gap-4 grid-flow-row">
    <div className="md:col-span-2 pb-10 ml-0 bg-black">
        <div className="md:w-1/2  sm:w-full ml-10 p-10 align-middle">
        <Content title="RESTARAUNTS"
        subtitle="Events"
        content="Lorem ipsum dolor sit amet consectetur adipisicing elit. Quod neque minus, ducimus dolore veniam aspernatur optio quibusdam itaque, placeat, aliquam sit hic! Nam nihil fugiat aut totam, sequi unde nostrum."/>
<div className=" p-3 w-1/2">
  <Button href="/events" isColour={true} label='DISCOVER'/>
  </div>
</div> 
</div>
  <div className="-ml-30 w-full z-20">
       <EventCaro/>
      </div>
  </div>
     <div className="banquet h-screen mt-10 bg-cover bg-center md:p-20 p-10">
      <div className="container md:ml-20 overlay align-middle w-full md:w-1/2  justify-center md:p-10 p-5">
        <div className=" md:mx-auto">
        <Content title="BANQUET HALL" subtitle="The beachside setting
for all occasions" content="Inspire your guests with breathtaking views across
the ocean"/>
<div className=" pt-5 sm:ml-6 gap-5 flex flex-wrap md:gap-4 sm:gap-4">
  <Button href="/events" isColour={true} label="DISCOVER MEETINGS & EVENTS"/>
  <Button href="/halls" label="DISCOVER WEDDINGS"/>
</div>
        </div></div>
     </div>
   <Footer/>
    </div>
    
    
  )
}

export default Home